module.exports = __webpack_public_path__ + "img/on-process-booking-cargo.c6a5373a.svg";